export const WEEK_DAY_LABELS: Record<number, string> = {
	0: "Domingo",
	1: "Segunda-feira",
	2: "Terça-feira",
	3: "Quarta-feira",
	4: "Quinta-feira",
	5: "Sexta-feira",
	6: "Sábado",
};

export const WEEK_DAY_OPTIONS = [1, 2, 3, 4, 5, 6].map((day) => ({
	value: day,
	label: WEEK_DAY_LABELS[day],
}));
